<template>
  <div class="routerContent">
    <div class="card df p10">
      <el-button type="primary" @click="editData()" v-if="!disabled">添加</el-button>
    </div>
<!--    <template>
      <p>种公羊数量{{zgySum}}</p>
      <p>基础母羊数量{{jcmySum}}</p>
      <p>羔羊数量{{gySum}}</p>
    </template>-->
    <div class="fg1 df fdc h14">
      <jh-table class="fg1 ova" height="100%" size="small" :stripe="true" row-key="id" ref="jhTable" :columnList="columnList" :data="dataList" @selection-change="handleSelectionChange" @deleteData="delData" />
      <div class="tc pt10 pb10">
        <jh-pager :pager.sync="pager" @getData="getData" />
      </div>
    </div>
    <infoDialog @onSuccess="getData" :infoDialogConfig="infoDialogConfig" v-if="infoDialogVisible" :infoDialogVisible.sync="infoDialogVisible" />
  </div>
</template>

<script>
export default {
  name: "outSheep",
  components: {
    infoDialog: (resolve) => resolve(require("./components/infoDialog")),
  },
  props: {
    step: {
      type: Object,
      default: () => {},
    },
    breedBatch: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pager: {
        size: 20,
        total: 0,
        page: 1,
      },
      showForm: false, //高级搜索
      showSelect: false, //表格动态列
      options: [], //模块数组
      searchForm: {
        slauId: '',
        compId: '',
        compBh: '',
        compMc: '',
        compQyjm: '',
        slauBatchNum: '',
        batchNum: '',
        tzBatchNum: '',
        slauClyy: '',
        slauClsl: '',
        slauCzr: '',
        slauClrq: '',
        slauSfyxr: '',
        slauEwm: '',
        createTime: '',
        createUserId: '',
        createUserName: '',
      },
      infoDialogVisible: false,
      infoDialogConfig: {
        title: "添加信息",
      },
      dataRoleTypes: [],
      //企业名称
      compList: [],
      //出栏原因
      slauClyyList: [],
      //是否已写入
      slauSfyxrList: [],
      dataList: [], //表格数据
      selectList: [], //选中数组
      selectCol: [], //选中列
      //表格列数组  不是用动态列可以直接赋值给columnList 不需要computed
      allColumnList: [{
          type: "index",
          align: "center",
        },
        {
          prop: "slauBatchNum",
          label: "出栏批次号",
          align: "center",
          minWidth: "120px",
        },
        {
          prop: "slauClyyName",
          label: "出栏原因",
          align: "center",
          minWidth: "120px",
        },
        {
          prop: "slauClsl",
          label: "出栏数量",
          align: "center",
          minWidth: "120px",
        },
        {
          prop: "slauClrq",
          label: "出栏时间",
          align: "center",
          minWidth: "120px",
          render: (h, scope) => {
            return h(
              "div",
              this.formatDate(scope.row.slauClrq, "yyyy-MM-dd")
            );
          },
        },
        /*{
          prop: "targTime",
          label: "耳标使用时间",
          align: "center",
          minWidth: "145px",
          render: (h, scope) => {
            return h(
              "div",
              this.formatDate(scope.row.targTime, "yyyy-MM-dd")
            );
          },
        },
        {
          prop: "slauSfyxrName",
          label: "是否已写入",
          align: "center",
          minWidth: "120px",
        },*/
        {
          prop: "",
          fixed: "right",
          label: "操作",
          align: "center",
          width: "120px",
          render: (h, scope) => {
            let btn = [];
            if (this.disabled) {
              btn = [
                h("el-button", {
                  on: {
                    click: this.showData.bind(this, scope.row),
                  },
                  props: {
                    type: "text",
                  },
                  domProps: {
                    innerHTML: "查看",
                  },
                }),
              ];
            } else {
              btn = [
                h("el-button", {
                  on: {
                    click: this.editData.bind(this, scope.row),
                  },
                  props: {
                    type: "text",
                  },
                  domProps: {
                    innerHTML: "修改",
                  },
                }),
                h("el-button", {
                  on: {
                    click: scope._self.deleteRow.bind(this, scope.row),
                  },
                  props: {
                    type: "text",
                  },
                  domProps: {
                    innerHTML: "删除",
                  },
                }),
              ];
            }
            return h("div", {}, btn);
          },
        },
      ],
    };
  },
  computed: {
    columnList: function () {
      return this.allColumnList.filter(
        (item) =>
          !item.label ||
          this.selectCol.includes(item.label) ||
          item.label === "操作"
      );
    },
    /*zgySum:{
      get(){
        return this.breedBatch.batchZgy + this.breedBatch.batchWclZgy;
      },
    },

    jcmySum:{
      get(){
        return this.breedBatch.batchJcmy + this.breedBatch.batchWclJcmy;
      },
    },

    gySum:{
      get(){
        return this.breedBatch.batchGysl + this.breedBatch.batchWclGysl;
      },
    },*/
  },
  async mounted() {
    await this.getEnmuList();
    //await this.doGetSysComps();
    this.getData();
    this.searchForm.batchNum = this.step.batchNum;

  },
  created() {
    this.selectCol = this.allColumnList
      .map(item => item.label)
      .filter(item => item && item != "操作");
  },
  methods: {

    handleSelectionChange(row) {
      this.selectList = row;
    },
    batchDelete() {
      if (this.selectList.length === 0) {
        this.$message.warning("当前未选择数据");
        return;
      }
      this.$confirm("此操作将永久删除这些项, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let params = [];
          for (let i = 0; i < this.selectList.length; i++) {
            params[i] = this.selectList[i].btiId;
          }
          this.$api.formPost("/api/major/tz/slaugh/doRmByIds", {
            ids: params
          }).then((res) => {
            this.selectList = [];
            this.$refs.jhTable.$refs.formTable.clearSelection();
            this.$message.success("删除成功");
            this.getData();
          });
        })
        .catch(() => {});
    },

    getData(type) {
      if (type === "refresh") {
        this.pager.page = 1;
      }
      let params = {
        pageNum: this.pager.page,
        pageSize: this.pager.size,
        ...this.searchForm,
        batchNum: this.step.batchNum,
      };
      let load = this.$loading({
        target: this.$refs.jhTable.$el,
      });
      this.showForm = false;
      this.$api
        .formPost("/api/major/tz/slaugh/doGetList", params)
        .then((res) => {
          if (res.retHead.code == "0000000") {
            load.close();
            this.dataList = res.retBody.list;
            this.dataList.forEach(item => {
              this.slauClyyList.map(slauClyy => {
                if (slauClyy.codeValue == item.slauClyy) {
                  item.slauClyyName = slauClyy.codeName;
                }
              });
              this.slauSfyxrList.map(slauSfyxr => {
                if (slauSfyxr.codeValue == item.slauSfyxr) {
                  item.slauSfyxrName = slauSfyxr.codeName;
                }
              });
              this.pager.total = res.retBody.total;
            });
          }
        })
    },
    // 编辑
    editData(row) {
      this.infoDialogConfig.slauClyyList = this.slauClyyList;
      this.infoDialogConfig.slauSfyxrList = this.slauSfyxrList;
      this.infoDialogConfig.compId_g = this.breedBatch.compId;
      this.infoDialogConfig.compBh_g = this.breedBatch.compBh;
      this.infoDialogConfig.compMc_g = this.breedBatch.compMhXmAndCompMc;
      this.infoDialogConfig.batchNum = this.searchForm.batchNum;
      if (row) {
        this.infoDialogConfig.title = "修改信息";
        this.infoDialogConfig.data = JSON.parse(JSON.stringify(row));
      } else {
        this.infoDialogConfig.title = "添加信息";
        this.infoDialogConfig.data = null;
      }
      this.infoDialogVisible = true;
    },

    showData(row) {
      this.infoDialogConfig.slauClyyList = this.slauClyyList;
      this.infoDialogConfig.slauSfyxrList = this.slauSfyxrList;
      this.infoDialogConfig.compId_g = this.breedBatch.compId;
      this.infoDialogConfig.compBh_g = this.breedBatch.compBh;
      this.infoDialogConfig.compMc_g = this.breedBatch.compMhXmAndCompMc;
      this.infoDialogConfig.batchNum = this.searchForm.batchNum;
      if (row) {
        this.infoDialogConfig.title = "查看信息";
        this.infoDialogConfig.data = JSON.parse(JSON.stringify(row));
        this.infoDialogConfig.disabled = true;
      }
      this.infoDialogVisible = true;
    },

    delData(row) {
      let params = {
        id: row.slauId,
      };
      this.$api
        .formPost("/api/major/tz/slaugh/doRmById", params)
        .then((res) => {
          this.$message.success("删除成功");
          this.getData();
        });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      for (const key in this.searchForm) {
        this.searchForm[key] = "";
      }

      this.searchForm.organRecurFlag = '1'
      this.currentPage = 1;
      this.getData("refresh");
    },
    initData() {
      this.getData("refresh");
    },
    getEnmuList() {
      return new Promise(resolve => {
        let params = ["clyy", "logic"]
        this.$api.formPost("/api/basfun/syscode/query/doGetItemsByCodes", {
          sysCodes: params.join(",")
        }).then(res => {
          if (res.retBody) {
            params.map(item => {
              if (item == "clyy") {
                this.slauClyyList = res.retBody[item];
              }
              if (item == "logic") {
                this.slauSfyxrList = res.retBody[item];
              }
            })
            resolve();
          }
        }).catch(() => {});
      })
    },

    //获取企业信息
    doGetSysComps() {
      return new Promise(resolve => {
        let params = {
          id: JSON.parse(sessionStorage.getItem('user')).organId
        };
        this.$api.formPost("/api/major/sycomp/doGetById", params).then(res => {
          if (res.retBody) {
            if (res.retHead.code == "0000000") {
              this.compList[0] = res.retBody;
            }
            resolve();
          }
        }).catch(() => {});
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.bank {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/outSheep/index.vue